<template>

    <div class="w-full h-screen flex flex-col overflow-hidden justify-center items-center  top-0 papsi-loading-screen z-50 fixed">
      <img class="papsi-mascot w-1/6 mb-10" :src="getMediaPath('papsi_kalabaw.png')"/>
      <div class="text-[#016B00] text-5xl font-bold mb-10 flex items-center justify-center">
          <p class="uppercase">Loading</p>
          <span class="dots-container">
              <span class="dots"></span>
          </span>
      </div>
      <p class="text-grey-darker text-3xl w-1/2 text-center"></p>
  </div>
  </template>
  
  <script>
  
  export default {
    name: 'v-load',
    data() {
        return {
        };
    },
  
    mounted() {
     
    },
    methods:{
      getMediaPath(path) {
        return process.env.VUE_APP_IMG_CDN + path;
      },
    }
  };
  </script>
  
  <style scoped>
    .papsi-loading-screen {
      background: radial-gradient(circle, 
                  rgba(229, 231, 235, 1) 10%, 
                  rgb(149, 155, 167) 100%);
    }
  
    @keyframes mascot-wave {
      0%, 100% { 
          transform: translateY(0);
      }
      50% {
          transform: translateY(-10px);
      }
    }
  
    .papsi-mascot {
      animation: mascot-wave 1s ease-in-out infinite;
      transform-origin: top center;
    }
  
    .dots-container {
      display: inline-block;
      width: 2em;
      text-align: left;
    }
  
    @keyframes dot-blink {
      0% { content: ""; }
      25% { content: "."; }
      50% { content: ".."; }
      75% { content: "..."; }
      100% { content: ""; }
    }
  
    .dots::after {
      animation: dot-blink 2s steps(4, end) infinite;
      content: ""; /* Initial state */
    }
  </style>